import Api from '../api'
import { AxiosResponse} from "axios";
import DynamicObject from "../../models/dynamic-object";

export default (productAssignId:string, qty:number, posSource : string, referralSource: string,config?: DynamicObject): Promise<AxiosResponse> => {
    const data = {"Payment":{"productAssignId":productAssignId, "qty":qty,absoluteUrl : window.location.href},"posSource":posSource,"referralSource": referralSource};
    const path = 'vas/create-bundle-payment'
    return Api.getInstance().request.post(`vas/create-bundle-payment`, data, path);
}